import React from 'react';
import { number, string } from 'prop-types';
import { Avatar, Box, CircularProgress, Typography } from '@mui/material';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';

const boxStyles = {
  alignItems: 'center',
  boxShadow: 1,
  display: 'flex',
  flexDirection: 'row',
  height: 74,
  justifyContent: 'flex-start',
  mt: 1,
  mx: 'auto',
  pl: 6,
};

const avatarClass = {
  backgroundColor: 'success.light',
  color: 'success.dark',
  fontSize: 16,
  height: 24,
  marginRight: 1.5,
  width: 24,
};

const SubmitProgressHeader = ({ copy, totalProgress }) => (
  <Box bgcolor="surface.white" sx={boxStyles}>
    {totalProgress !== 100 ? (
      <>
        <CircularProgress color="secondary" size={24} sx={{ marginRight: 1 }} />
        <Typography color="inherit" variant="h6">
          Total Progress&#8230; {totalProgress}%
        </Typography>
      </>
    ) : (
      <>
        <Avatar sx={avatarClass}>
          <CheckRoundedIcon />
        </Avatar>
        <Typography color="inherit" variant="h6">
          {copy}
        </Typography>
      </>
    )}
  </Box>
);

SubmitProgressHeader.propTypes = {
  copy: string,
  totalProgress: number.isRequired,
};

SubmitProgressHeader.defaultProps = {
  copy: 'All Setups Complete!',
};

export default SubmitProgressHeader;
